<template lang="pug">
.cp-feature-list
  .content-wrap.w.fix
    .arrow.arrowL(@click="handleClick(-1)")
    .arrow.arrowR(@click="handleClick(1)")
    .list-item
      transition-group(name="slide-fade", tag='div')
        .left.fl(v-for="(v, index) in list" v-if="index === currentIndex", :key="v.title")
          p {{ v.title }}
          p {{ v.detail }}
      .right.fr
        .arc(ref="arc")
        transition-group(name="scale-fade", tag="div")
          .wrap(v-for="(v, index) in list" v-if="index === currentIndex", :key="v.title")
            .img-wrap
              img(:src="v.imgSrc")
            .p-wrap
              .title {{v.descTitle || ''}}
              .label {{v.label[0]}}
              .label {{v.label[1]}}
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      list: [
        { title: '构建用户画像', detail: '整合海量数据，进行复合特征计算，实时提取用户标签，丰满企业用户画像。', descTitle: '意图标签拟合', label: ['文本转写、语义抽象', '标签提取、实时返回'], imgSrc: require('@/assets/yhhx.png') },
        { title: '全渠道覆盖', detail: '适配主流终端及在网环境，帮助企业无缝触达用户。助力企业多渠道商机转化。', descTitle: '', label: ['无缝触达', '商机转化'], imgSrc: require('@/assets/qqd.png') },
        { title: '真实口语对话', detail: '基于AI的语音交互，定向训练、泛化拟合、参数合成、智能打断。人机自然沟通。', descTitle: '', label: ['真实拟人', '自然沟通'], imgSrc: require('@/assets/zskydh.png') },
        { title: '数据智能营销', detail: '定制个性化方案，结合大数据、通信、人工智能，形成数据驱动的经营决策新要素。', descTitle: '', label: ['数据驱动', '个性化定制'], imgSrc: require('@/assets/sjznyx.png') },
      ],
      count: 0,
      timer: null,
      isAuto: true,
    }
  },
  computed: {
    currentIndex () {
      let index = this.count % 4
      if (index < 0) {
        index += 4
      }
      return index
    }
  },
  methods: {
    handleClick (step) {
      if (this.isAuto) {
        clearInterval(this.timer)
        this.isAuto = false
        setTimeout(() => {
          this.start()
        }, 1000)
      }
      this.changeActive(step)
    },
    changeActive (step) {
      this.count += step
      const deg = -90 + this.count * 90
      this.$refs['arc'].style.transform = `rotate(${deg}deg)`
    },
    showModal () {
      this.$emit('showModal', true)
    },
    start () {
      this.isAuto = true
      this.timer = setInterval(() => {
        this.changeActive(1)
      }, 3000)
    }
  },
  mounted () {
    this.start()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="stylus">
@import 'config'

.cp-feature-list
  // min-width 1800px
  height 552px
  background-image url('../../../assets/featureR.png'), url('../../../assets/featureL.png'), url('../../../assets/featureM.png')
  background-size 417px 552px, 1474px 552px, 100% 552px
  background-position right, left, left
  background-repeat no-repeat, no-repeat, no-repeat
  .content-wrap
    width $content-width
    height 552px
    padding-top 30px
    margin 0px auto
    position relative
    .arrow
      width 35px
      height 60px
      margin-top 187px
      cursor pointer
      transition all .3s
      &:hover
        transform scale(1.1)
      &::before
        content ''
        display block
        width 7px
        height 34px
        background #FFF
        box-shadow 0px 0px 10px #FFFFFF
      &::after
        content ''
        display block
        width 7px
        height 34px
        background #FFF
        box-shadow 0px 0px 10px #FFFFFF
    .arrowL
      float left
      &::before
        transform translate(13px, 3px) rotate(45deg)
      &::after
        transform translate(13px, -11px) rotate(-45deg)
    .arrowR
      float right
      &::before
        transform translate(13px, 3px) rotate(-45deg)
      &::after
        transform translate(13px, -11px) rotate(45deg)
    .left
      width 357px
      position absolute
      top 184px
      left 78px
      p
        &:first-child
          margin-bottom 15px
          font-size 31px
          color #FFFFFF
        &:nth-child(2)
          font-size 16px
          color rgba(244,245,247,1)
      .btn
        display block
        width 166px
        height 50px
        box-shadow 0px 2px 4px 0px rgba(255,255,255,0.09)
        border-radius 5px
        border 2px solid rgba(255,255,255,1)
        line-height 45px
        text-align center
        font-size 18px
        color #FFFFFF
        cursor pointer
        transition all .3s
        &:hover
          background rgba(255,255,255,.4)
    .right
      width 506px
      height 506px
      margin-right 37px
      position relative
      background url('../../../assets/chilun.png') center / 100% no-repeat
      .arc
        position absolute
        width 506px
        height 506px
        background url('../../../assets/arc.png') center / 100% no-repeat
        transform rotate(-90deg)
        transition all 0.5s ease
      .wrap
        text-align center
        position absolute
        width 100%
        .img-wrap
          margin 51px auto 0px
          img
            width 400px
        .p-wrap
          font-size 16px
          .title
            font-size 18px
            margin-bottom 8px
            min-height: 27px
  .slide-fade-enter-active
    transition all .5s ease .5s
  .slide-fade-leave-active
    transition all .5s ease
  .slide-fade-enter, .slide-fade-leave-to
    transform translateY(20px)
    opacity 0
  .scale-fade-enter, .scale-fade-leave-to
    transform scale(0)
    opacity 0
  .scale-fade-enter-active
    transition all .5s ease
  .scale-fade-leave-active
    transition all .5s ease
</style>
